module.exports = __webpack_public_path__ + "img/8.df33c42c.png";